import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PatientARTransaction } from './models/patient-ar-transaction';
import { TREATMENT_PLAN_STATUS } from 'src/app/models/constants/treatment-plan-status.model';

@Injectable({
  providedIn: 'root'
})
export class PatientPortalService {

  constructor(
    private http: HttpClient
  ) { }

  sendSMSAppointment(patientId: string, appointmentId: string) {
    return this.http.post<any>(`/api/patientportal/${patientId}/appointments/${appointmentId}/sendsms`, {});
  }

  getPatientInfo(patientId: string): Observable<any> {
    return this.http.get<any>(`/api/patient/${patientId}`)
  }

  getValidValueByName(validValueName: string) {
    return this.http.get<any>(`/api/valid-values/${validValueName}`);
  }

  getPatientAppointments(patientId: string) {
    return this.http.get<any>(`api/patientportal/${patientId}/appointments`);
  }

  getPatientForms(patientId: string) {
    if(patientId == null || patientId == undefined || patientId == ''){
      return new Observable<any>();
    }

    return this.http.get<any>(`api/get-patient-general-forms/${patientId}`);
  }

  getPatientTreatmentPlans(patientId: string) {
    return this.http.get<any>(`api/patientportal/${patientId}/treatmentplans`);
  }
  getAppointmentForms(CaseWorkItemId, CaseProcedureId) {
    return this.http.get<any>(`/api/infograb/getAppointmentForms/${CaseWorkItemId}/${CaseProcedureId}`);
  }

  getPatientInsuranceCard(patientId) {
    return this.http.get<any>(`/api/infograb/getPatientInsuranceCard/${patientId}`);
  }

  getAppointmentInformation(AppointmentId: string) {
    return this.http.get<any>(`/api/infograb/getAppointmentInformation/${AppointmentId}`);
  }

  getAppointmentFormProgress(CaseWorkItemFormsId: string) {
    return this.http.get<any>(`/api/infograb/getAppointmentFormProgress/${CaseWorkItemFormsId}`);
  }

  savePatientInsuranceCard(patientId: string, card: any) {
    return this.http.post<any>(`/api/patient/${patientId}/savePatientInsuranceCard`, card);
  }

  setAppointmentStatus(appointmentId: string, status: string) {
    return this.http.post<any>(`/api/infograb/setAppointmentStatus/${appointmentId}/${status}`, {});
  }

  rescheduleAppointment(patientId: string, appointmentId: string, reason: string, patientName: string, patientPhone: string){
    var payload ={
      appointmentId: appointmentId,
      reason: reason,
      patientName: patientName,
      patientPhone:patientPhone
    };
    return this.http.post<any>(`api/patientportal/${patientId}/appointments/${appointmentId}/reschedule`, payload);
  }

  getPatientTransactions(patientId: string): Observable<any[]> {
    return this.http.get<PatientARTransaction[]>(`api/accountReceivable/getLedgerForPatient2/${patientId}`);
  }

  requestAppointment(patientId: string, requestedDate: Date, reason: string, patientName: string, patientPhone: string){
    var payload ={
      requestedDate: requestedDate,
      reason: reason,
      patientName: patientName,
      patientPhone:patientPhone
    };
    return this.http.post<any>(`api/patientportal/${patientId}/appointments/request`, payload);
  }

  getPatientTreatmentPlan(patientId: string, treatmentPlanId: string) {
    return this.http.get<PatientARTransaction[]>(`api/patientportal/${patientId}/treatmentplans/${treatmentPlanId}`);
  }

  sendPatientTreatmentPlanApproval(patientId: string, treatmentPlanId: string) {
    var payload ={
      statusResponse: TREATMENT_PLAN_STATUS.AcceptedByPatient
    };
    return this.http.post<any[]>(`api/patientportal/${patientId}/treatmentplans/${treatmentPlanId}`, payload);
  }

  sendPatientTreatmentPlanRejection(patientId: string, treatmentPlanId: string) {
    var payload ={
      statusResponse: TREATMENT_PLAN_STATUS.RejectedByPatient
    };
    return this.http.post<any[]>(`api/patientportal/${patientId}/treatmentplans/${treatmentPlanId}`, payload);
  }
}

